export { Autocomplete } from "@mantine/core";
export type { AutocompleteProps } from "@mantine/core";
export { autocompleteOverrides } from "./Autocomplete.config";
